<template>
	<ClientOnly>
		<Teleport to="#teleport-target" v-bind="teleportProps">
			<slot />
		</Teleport>
	</ClientOnly>
</template>
<script setup lang="ts">
	import type {TeleportProps} from 'vue';

	defineProps<{
		teleportProps?: TeleportProps
	}>();
</script>
